import React from 'react'

/**
 * FootballIcon – SVG icon component.
 *
 * Props:
 * - flip: when true, rotates the icon to face opposite
 * - className: optional Tailwind / custom classes.
 * - Any other valid SVG props (width, height, etc.).
 */
export interface FootballIconProps extends React.SVGProps<SVGSVGElement> {
  /** Rotates the icon to face opposite. */
  flip?: boolean
}

export const FootballIcon: React.FC<FootballIconProps> = ({
  flip = false,
  className,
  style,
  width = 12,
  height = 11,
  ...rest
}) => {
  const combinedStyle: React.CSSProperties = {
    transform: flip ? 'rotate(55deg)' : undefined,
    transformOrigin: flip ? '50% 50%' : undefined,
    ...style,
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={combinedStyle}
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M0.196029 7.89104C0.14092 8.76791 0.393515 9.15782 1.2212 9.47121C1.29163 9.49872 1.36322 9.52511 1.43589 9.54574C1.89095 9.67724 2.3536 9.75831 2.85266 9.77265C2.09655 8.60262 1.35878 7.45922 0.617192 6.31096C0.442872 6.58413 0.227528 7.39695 0.196029 7.89104Z"
        fill="#815337"
      />
      <path
        d="M11.6456 2.57792C11.6407 2.01882 11.3965 1.60583 10.8738 1.40962C10.4523 1.25085 10.007 1.1512 9.56751 1.04321C9.38687 0.999123 9.19504 1.00176 8.97316 0.979465C9.73563 2.16044 10.4715 3.30109 11.2186 4.45733C11.454 4.0539 11.649 3.1376 11.6456 2.57792Z"
        fill="#815337"
      />
      <path
        d="M9.29183 3.23535C8.83401 2.52567 8.37808 1.81395 7.91295 1.10915C7.86952 1.04402 7.7639 0.972743 7.6934 0.978632C6.24737 1.10028 4.88314 1.46936 3.67178 2.3011C2.60272 3.03457 1.8096 4.00734 1.17668 5.1194C1.14281 5.17991 1.14383 5.29696 1.18066 5.35512C2.10198 6.79516 3.03053 8.23194 3.96294 9.66506C3.99822 9.71838 4.09531 9.76449 4.16036 9.76082C4.39314 9.74791 4.626 9.71905 4.85733 9.68511C5.98439 9.51654 7.05414 9.17689 8.01361 8.55741C9.15002 7.82407 9.9892 6.81502 10.6649 5.65974C10.7393 5.53264 10.7224 5.44289 10.6466 5.32781C10.1917 4.63306 9.74314 3.93331 9.29183 3.23535ZM8.74475 4.38636L8.49252 3.99662L7.96387 4.33255L8.21676 4.72313L7.87347 4.94159L7.62145 4.55113L7.09266 4.88817L7.3456 5.27838L7.00193 5.4968L6.74991 5.10633L6.22151 5.44229L6.47365 5.83277L6.12996 6.05144L5.87781 5.66096L5.34986 5.99736L5.60164 6.38779L5.25872 6.6063L5.00657 6.21582L4.47859 6.55247L4.72998 6.94298L4.38749 7.16104L4.1351 6.77053L3.60673 7.10725L3.85813 7.49764L3.51556 7.71645L2.77656 6.57176L3.11966 6.35378L3.37215 6.74355L3.90064 6.40684L3.64803 6.01706L3.99171 5.79751L4.24379 6.18848L4.77107 5.85238L4.51967 5.46199L4.86284 5.24351L5.11508 5.63325L5.64298 5.29723L5.39084 4.90674L5.73478 4.68811L5.98655 5.07854L6.51433 4.7425L6.26281 4.3521L6.60602 4.13325L6.85779 4.52368L7.38644 4.18775L7.1343 3.79727L7.47751 3.57841L7.72965 3.9689L8.25778 3.63214L8.00563 3.24166L8.34887 3.02357L9.08796 4.16751L8.74475 4.38636Z"
        fill="#815337"
      />
    </svg>
  )
}

export default FootballIcon
